module.exports = __webpack_public_path__ + "img/20_maska_kvadrat-ten.e464fa9.svg";